import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { sleep } from '../../../smoothr-web-app-core/utils/utils';
import Table from '../../../smoothr-web-app-core/models/Table';
import { TranslateService } from '@ngx-translate/core';
import { BarcodeFormat } from '@zxing/library';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { MapPage } from 'src/app/pages/map/map.page';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { environment } from 'src/environments/environment';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

@Component({
	selector: 'app-scan-qr',
	templateUrl: './scan-qr.component.html',
	styleUrls: ['./scan-qr.component.scss'],
})
export class ScanQrModal implements OnInit {
	allowedFormats = [BarcodeFormat.QR_CODE, BarcodeFormat.DATA_MATRIX, BarcodeFormat.AZTEC];
	scannedResult: string | null = null;
	hasDevices = false;
	availableDevices: MediaDeviceInfo[] = [];
	selectedDevice: MediaDeviceInfo | undefined;
	venue: Venue;
	type: string = '';
	scanning = true;
	loading = false;
	@ViewChild('scanner') scanner!: ZXingScannerComponent;

	constructor(
		protected repository: RepositoryService,
		private snackBarCtrl: MatSnackBar,
		private router: Router,
		private modalCtrl: ModalController,
		public translate: TranslateService
	) {}

	/**
	 * returns table number
	 */
	static async show(modalCtrl: ModalController, venue: Venue): Promise<Table> {
		const resultScan = await modalCtrl.create({
			component: ScanQrModal,
			cssClass: 'item-modal qr-code-scan',
			componentProps: {
				venue,
			},
		});
		await resultScan.present();
		const res = (await resultScan.onDidDismiss()).data;
		await sleep(100);
		return res;
	}
	ngOnInit() {}
	close() {
		this.modalCtrl.dismiss();
	}

	startScanning() {
		this.scanning = true;
	}

	stopScanning() {
		this.scanner?.reset();
	}

	scanSuccessHandler($event: any) {
		this.loading = true;
		this.stopScanning();
		this.scanning = false;

		try {
			const tableNumber = this.getTableNumberFromUrl($event);

			if (!tableNumber) {
				throw new Error('Invalid QR');
			}

			this.takeOverOrder(tableNumber);
		} catch (e) {
			this.loading = false;
			this.snackBarCtrl.dismiss();
			this.snackBarCtrl.open('Bitte QR-Code überprüfen', null, {
				duration: 2000,
			});
			this.scanning = true;
		}
	}

	getTableNumberFromUrl(url: string): string | null {
		try {
			const parts = url.split('/').filter(Boolean);
			return parts[parts.length - 1] || null;
		} catch {
			return null;
		}
	}

	async takeOverOrder(tableNumber: string) {
		console.log(tableNumber);
		if (tableNumber === null) {
			this.loading = false;
			this.snackBarCtrl.dismiss();
			this.snackBarCtrl.open('Bitte QR-Code überprüfen', null, {
				duration: 2000,
			});
			return;
		}
		try {
			await sleep(100);

			const table = (await Api.getTable(this.venue?._id, tableNumber)).data;
			console.log(tableNumber);
			await sleep(100);
			await this.modalCtrl.dismiss(table);
		} catch (e) {
			console.log(e);
			this.snackBarCtrl.dismiss();
			this.snackBarCtrl.open('Fehler beim Abrufen des Tisches: ' + e, null, {
				duration: 2000,
			});
		} finally {
			this.scanning = true;
		}
		this.loading = false;
	}

	onDeviceSelectChange(event: Event) {
		const target = event.target as HTMLSelectElement; // Fix: Properly typecast EventTarget
		this.selectedDevice = this.availableDevices.find(device => device.deviceId === target.value);
	}

	// onHasDevices(hasDevices: boolean) {
	// 	this.hasDevices = hasDevices;
	// }

	// onDevicesFound(devices: MediaDeviceInfo[]) {
	// 	this.availableDevices = devices;
	// 	if (devices.length > 0) {
	// 		this.selectedDevice = devices[0]; // Fix: Ensure a device is selected initially
	// 	}
	// }

	onError(error: any) {
		console.error('Barcode scanning error:', error);
	}
}
